import {
  MethodInfo,
  NextServerStreamingFn,
  NextUnaryFn,
  RpcInterceptor,
  RpcOptions,
  ServerStreamingCall,
  UnaryCall,
} from '@protobuf-ts/runtime-rpc'

export class StaticBearerInterceptor implements RpcInterceptor {
  constructor(private accessToken?: string) {}

  interceptUnary(
    next: NextUnaryFn,
    method: MethodInfo,
    input: object,
    options: RpcOptions,
  ): UnaryCall {
    if (!options.meta) options.meta = {}

    if (this.accessToken) {
      options.meta.Authorization = `Bearer ${this.accessToken}`
    }

    return next(method, input, options)
  }

  interceptServerStreaming(
    next: NextServerStreamingFn,
    method: MethodInfo,
    input: object,
    options: RpcOptions,
  ): ServerStreamingCall {
    if (!options.meta) options.meta = {}
    options.meta.Authorization = `Bearer ${this.accessToken}`

    return next(method, input, options)
  }
}
